// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RouterTabs_wrapper__nRXsP"};